const parseSafely = (value, fallbackValue) => {
  try {
    return value ? JSON.parse(value) : fallbackValue;
  } catch (error) {
    return fallbackValue;
  }
};

export const partnerStorage = {
  get(key, fallbackValue = null) {
    return parseSafely(localStorage.getItem(key), fallbackValue);
  },

  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  remove(key) {
    localStorage.removeItem(key);
  },
};
